var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrapper"},[_c('HeaderBar',{attrs:{"isMobileMenuOpen":_vm.mobileOpen},on:{"mobileOpenChanged":_vm.onMobileOpenChanged}}),_c('Home',{attrs:{"isMobileMenuOpen":_vm.mobileOpen},on:{"mobileOpenChanged":_vm.onMobileOpenChanged}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }